import React from 'react';
import {
  useFasterPayoutsQueryPagerProps,
  useMcFasterPayoutsQuery,
} from '../../hooks/faster-payouts/queries';
import { FasterPayoutsTableContent } from './FasterPayoutsTableContent';
import { TableFooter } from '../components/TableFooter';

export const McFasterPayoutsTable = () => {
  const props = useFasterPayoutsQueryPagerProps({
    source: 'mc',
    useUrlFilters: false,
  });
  return (
    <>
      <FasterPayoutsTableContent useQuery={useMcFasterPayoutsQuery} />
      <React.Suspense fallback={null}>
        <TableFooter paginationProps={props} />
      </React.Suspense>
    </>
  );
};

export default McFasterPayoutsTable;
